<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12,3C11.76,3,11.559999999999999,3.09,11.379999999999999,3.23C11.379999999999999,3.23,11.370000000000001,3.22,11.370000000000001,3.22C11.370000000000001,3.22,7,6.720000000000001,7,6.720000000000001C7,6.720000000000001,7,4,7,4C7,3.45,6.55,3,6,3C6,3,5,3,5,3C4.45,3,4,3.45,4,4C4,4,4,12,4,12C4,12.55,4.45,13,5,13C5,13,6,13,6,13C6.55,13,7,12.55,7,12C7,12,7,9.280000000000001,7,9.280000000000001C7,9.280000000000001,11.379999999999999,12.78,11.379999999999999,12.78C11.379999999999999,12.78,11.39,12.77,11.39,12.77C11.559999999999999,12.91,11.76,13,12,13C12.55,13,13,12.55,13,12C13,12,13,4,13,4C13,3.45,12.55,3,12,3C12,3,12,3,12,3Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'StepBackward',
} as DefineComponent
</script>
